export default "__VITE_ASSET__c51c372e__"